import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';

interface CostCenterDonutChartProps {
  data: Array<{ costCenterId: string | null; costCenter: string; value: string; count: number }>;
}

const PALETTE = [
  '#3b82f6', '#22c55e', '#f97316', '#eab308', '#a855f7',
  '#06b6d4', '#ec4899', '#84cc16', '#f43f5e', '#0ea5e9',
];
const brl = (v: number) =>
  v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });

export function CostCenterDonutChart({ data }: CostCenterDonutChartProps) {
  const chart = data.map((r) => ({ name: r.costCenter, value: Number(r.value) })).filter((r) => r.value > 0);
  if (chart.length === 0) {
    return (
      <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
        <h3 className="text-sm font-semibold text-gray-900">Valor por centro de custo</h3>
        <p className="mt-3 text-sm text-gray-500">Sem ativos com valor no filtro atual.</p>
      </div>
    );
  }
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
      <h3 className="text-sm font-semibold text-gray-900">Valor por centro de custo (top 10)</h3>
      <div className="mt-3 h-72">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={chart} dataKey="value" nameKey="name"
              innerRadius={50} outerRadius={90} paddingAngle={2}
            >
              {chart.map((_, i) => (
                <Cell key={i} fill={PALETTE[i % PALETTE.length]} />
              ))}
            </Pie>
            <Tooltip formatter={(v: number) => brl(v)} />
            <Legend layout="vertical" align="right" verticalAlign="middle" wrapperStyle={{ fontSize: 11 }} />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
